/**
 * Roles that can be granted to a user from the Ionic apps.
 *
 * A role groups the capabilities that the user will get in the apps once authenticated. These are
 * the app-side names; the mapping to the backend contact `categories` lives in the infrastructure
 * layer (user mapper).
 */
export enum EUserRole {
  DRIVER = 'DRIVER',
  CARRIER_ADMIN = 'CARRIER_ADMIN',
  SHIPPER_ADMIN = 'SHIPPER_ADMIN',
  CREATE_DECA_AS_CARRIER = 'CREATE_DECA_AS_CARRIER',
  CREATE_DECA_AS_SHIPPER = 'CREATE_DECA_AS_SHIPPER',
  DECA_DRIVER = 'DECA_DRIVER',
}
